import React from "react";
import styles from "./FoundationalStage.module.css";
import { cleanLines, stripBoldTitle } from "../OnboardingStage/utils";

const parseRoadmap = (md = "") => {
  const lines = stripBoldTitle(cleanLines(md));
  const full = lines.join(" ").trim();

  // Try to split by arrow separator (→)
  const arrowMatch = full.match(/sequence:\s*(.*)/i);
  const sequence = arrowMatch ? arrowMatch[1] : full;

  const steps = sequence
    .split(/\s*→\s*/)
    .map((s) => s.trim().replace(/\.$/, ""))
    .filter(Boolean);

  return { steps };
};

const RoadmapMilestones = ({ markdown = "" }) => {
  const { steps } = parseRoadmap(markdown);
  if (!steps.length) return null;

  return (
    <div className={styles.container}>
      <h3 className={styles.heading}>Roadmap & Milestones</h3>
      <div className={styles.roadmapCard}>
        {steps.map((step, idx) => (
          <div key={idx} className={styles.roadmapStep}>
            <div className={styles.stepNumber}>{idx + 1}</div>
            <div className={styles.stepText}>{step}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RoadmapMilestones;
